import { uniqBy } from "lodash-es";

import {
  Activity,
  EntityType,
  EntityTypesSupportingRoutes,
} from "@mapmycustomers/shared/types/entity";

const getValidStops = (activities: Activity[], entityType: EntityTypesSupportingRoutes) =>
  uniqBy(
    activities.filter(({ account, contact }) =>
      entityType === EntityType.COMPANY ? account?.geoPoint : contact?.geoPoint
    ),
    entityType === EntityType.COMPANY ? "account.id" : "contact.id"
  );

export default getValidStops;
